var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "mySmallModalLabel",
        "aria-hidden": "true",
        id: "mi-modal"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog modal-md" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            {
              staticClass:
                "modal-header header d-flex align-items-center justify-content-between py-3 px-3"
            },
            [
              _c("h5", { staticClass: "mb-0" }, [
                _vm._v(_vm._s(_vm.translations.are_you_sure))
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content py-2 px-3" }, [
            _c("div", { staticClass: "table-responsive" }, [
              _c(
                "table",
                { staticClass: "table borderless registration-table" },
                [
                  _c("tbody", [
                    _c("tr", { staticClass: "mt-3" }, [
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.translations.company_name) + ":")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.inputs.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "mt-3" }, [
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.translations.country) + ":")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.inputs.country))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "mt-3" }, [
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.translations.city) + ":")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.inputs.city))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "mt-3" }, [
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.translations.address) + ":")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.inputs.address))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "mt-3" }, [
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.translations.zip) + ":")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.inputs.zip))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "mt-3" }, [
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.translations.phone) + ":")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.inputs.phone))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "mt-3" }, [
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.translations.email_form) + ":")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.inputs.email))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "mt-3" }, [
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.translations.web) + ":")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.inputs.web))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "mt-3" }, [
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.translations.gps_lat) + ":")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.inputs.gps_lat))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("tr", { staticClass: "mt-3" }, [
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.translations.gps_lon) + ":")
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "border-0" }, [
                        _vm._v(_vm._s(_vm.inputs.gps_lon))
                      ])
                    ])
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-footer px-3 justify-content-center" },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-outline-primary",
                  attrs: { type: "button", id: "modal-btn-no" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.hideModal($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.translations.no))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", id: "modal-btn-yes" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.sendForm($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.translations.yes))]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }